/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  StaticWrapper,
  Hero,
  BannerText,
  BrandRibbon,
  EditableHTLWrapper,
  CobrandCardHorizontalFlexible,
  CardHorizontalFeature,
  CardVertical,
  CarouselGallery,
  Text,
  DataBlock,
  CardHorizontalMini,
  CardLayered,
  MiniCardCarouselContainer,
  VariableColumnContainer,
  AccordionContainerEnhanced,
  CardCarouselContainer,
  LinkBanner,
  IconBlock,
  RichText,
  TabContainer,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  Media,
  BannerLayered,
  Footer,
} from '@marriott/mi-common-static-components';
import { OHighlight, OBannerText } from '@marriott/mi-designsystem-components';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import {
  AccountContainerEditable,
  SignInEditable,
  SignInContentBlockEditable,
  AccountTableEditable,
} from '@marriott/mi-account-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { getAllowedComponentsForNonAuthorMode as getAllowedComponentsForNonAuthorModeUtil } from '@marriott/shared/mi-helper-utils';
import {
  BrgClaimForm,
  ContactUsForm,
  ContentTabs,
  LegalConsentValidator,
  LoyaltyTier,
  ModalPageContent,
  PrivacyRightsWrapper,
  PrivacyRightsWrapperV2,
  LegalSeparator,
  LegalMultiLink,
} from '@marriott/mi-legal-components';

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/text`]: Text,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-common-spa/components/content/bannertext`]: BannerText,
  [`mi-aem-common-spa/components/content/datablock`]: DataBlock,
  [`mi-aem-utils/components/content/o-highlight`]: OHighlight,
  [`mi-aem-utils/components/content/o-banner-text`]: OBannerText,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/card-mini-carousel-container`]: MiniCardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/carouselgallery`]: CarouselGallery,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: CobrandCardHorizontalFlexible,
  [`mi-aem-common-spa/components/content/tabcontainer`]: TabContainer,
  [`mi-aem-legal-spa/components/content/contactusform`]: ContactUsForm,
  [`mi-aem-legal-spa/components/content/multilinks`]: LegalMultiLink,
  [`mi-aem-legal-spa/components/content/contenttabs`]: ContentTabs,
  [`mi-aem-legal-spa/components/content/membertier`]: LoyaltyTier,
  [`mi-aem-legal-spa/components/content/legalconsents`]: LegalConsentValidator,
  [`mi-aem-legal-spa/components/content/legalmodal`]: ModalPageContent,
  [`mi-aem-legal-spa/components/content/privacyrightswrapper`]: PrivacyRightsWrapper,
  [`mi-aem-legal-spa/components/content/cpraccpawrapper`]: PrivacyRightsWrapperV2,
  [`mi-aem-legal-spa/components/separator`]: LegalSeparator,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-legal-spa/components/content/brgclaimform`]: BrgClaimForm,
  [`mi-aem-common-spa/components/content/media`]: Media,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  ['mi-aem-homepage-spa/components/content/universal-footer']: Footer,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
  [`mi-aem-account/components/content/accounttable`]: AccountTableEditable,
};

export const AEM_REACT_TITLE_MAPPING = {
  'mi-aem-common-spa/components/experiencefragment': 'Experience Fragment',
  'mi-aem-common-spa/components/common/staticwrapper': 'Static Wrapper',
  'mi-aem-common-spa/components/content/hero': 'Hero',
  'mi-aem-common-spa/components/content/brandribbon': 'Brand Ribbon',
  'mi-aem-common-spa/components/content/variablecolumncontainer': 'Variable Column Container',
  'mi-aem-common-spa/components/content/accordioncontainerenhanced': 'Accordion Container-Enhanced',
  'mi-aem-common-spa/components/content/text': 'Text',
  'mi-aem-common-spa/components/content/richtext': 'Rich Text',
  'mi-aem-common-spa/components/content/bannertext': 'Banner Text',
  'mi-aem-common-spa/components/content/datablock': 'Data Block',
  'mi-aem-utils/components/content/o-highlight': 'Hightlight',
  'mi-aem-utils/components/content/o-banner-text': 'Banner Text',
  'mi-aem-common-spa/components/content/cardhorizontalmini': 'Card Horizontal Mini-Standard',
  'mi-aem-common-spa/components/content/cardlayered': 'Card Layered',
  'mi-aem-common-spa/components/content/cardvertical': 'Card Vertical',
  'mi-aem-common-spa/components/content/cardhorizontalfeature': 'Card Horizontal Feature',
  'mi-aem-common-spa/components/content/card-mini-carousel-container': 'Card Mini Carousel Container',
  'mi-aem-common-spa/components/content/cardcarouselcontainer': 'Card Carousel Container',
  'mi-aem-common-spa/components/content/carouselgallery': 'Carousel Gallery',
  'mi-aem-common-spa/components/content/linkbanner': 'Link Banner',
  'mi-aem-common-spa/components/content/iconblock': 'Icon Block',
  'mi-aem-common-spa/components/content/cobrandcardhorizontalflexible': 'Cobrand-Card Horizontal Flexible',
  'mi-aem-common-spa/components/content/tabcontainer': 'Tab Container',
  'mi-aem-legal-spa/components/content/contactusform': 'ContactUs Form',
  'mi-aem-legal-spa/components/content/multilinks': 'Multi Links',
  'mi-aem-legal-spa/components/content/contenttabs': 'Content Tabs Component',
  'mi-aem-legal-spa/components/content/membertier': 'Member Tier',
  'mi-aem-legal-spa/components/content/legalconsents': 'Legal Consents',
  'mi-aem-legal-spa/components/content/legalmodal': 'Legal Modal',
  'mi-aem-legal-spa/components/content/privacyrightswrapper': 'Privacy Rights Wrapper',
  'mi-aem-legal-spa/components/content/cpraccpawrapper': 'CPRA and CCPA Wrapper (V2)',
  'mi-aem-legal-spa/components/separator': 'Separator',
  'mi-aem-common-spa/components/content/bannerlayered': 'Banner Layered',
  'mi-aem-legal-spa/components/content/brgclaimform': 'Brg Claim Form',
  'mi-aem-common-spa/components/content/media': 'Media',
  'mi-aem-homepage-spa/components/content/global-navigation': 'Global Navigation',
  'mi-aem-homepage-spa/components/content/utilityNavigation': 'Utility Navigation',
  'mi-aem-homepage-spa/components/content/primaryNavigation': 'Primary Navigation',
  'mi-aem-homepage-spa/components/content/universal-footer': 'Universal Footer',
  'mcom-book-spa/components/flyoutcontainer': 'Flyout Container',
  'mi-aem-account/components/content/accountcontainer': 'Account Container',
  'mi-aem-account/components/content/signin': 'Sign In',
  'mi-aem-account/components/content/signincontentblock': 'Sign In Content Block',
  'mi-aem-account/components/content/datapagecomponent': 'Data Page Component',
  'mi-aem-account/components/content/accounttable': 'Account Table Component',
};

export const getAllowedComponentsForNonAuthorMode = model => {
  return getAllowedComponentsForNonAuthorModeUtil(model, AEM_REACT_MAPPING, AEM_REACT_TITLE_MAPPING);
};

export const defineComponentMapping = (allowedComponents, pagePath, isAuthorMode, featureFlagLogo) => {
  const logger = global.loggerInstance?.('defineComponentMapping');
  const log = logger?.log || (() => {});
  const logError = logger?.error || (() => {});

  try {
    MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper);
    MapTo(`mi-aem-common-spa/components/content/hero`)(Hero);
    MapTo(`mi-aem-common-spa/components/content/brandribbon`)(props => (
      <BrandRibbon {...props} featureFlagLogo={featureFlagLogo} />
    ));

    MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(props => (
      <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));
    MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(props => (
      <AccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));
    MapTo(`mi-aem-common-spa/components/content/text`)(Text);
    MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText);
    MapTo(`mi-aem-common-spa/components/content/bannertext`)(BannerText);
    MapTo(`mi-aem-common-spa/components/content/datablock`)(DataBlock);
    MapTo(`mi-aem-utils/components/content/o-highlight`)(props => (
      <OHighlight {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-utils/components/content/o-banner-text`)(props => (
      <OBannerText {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini);
    MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered);
    MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
    MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);
    MapTo(`mi-aem-common-spa/components/content/card-mini-carousel-container`)(MiniCardCarouselContainer);
    MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
      <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));
    MapTo(`mi-aem-common-spa/components/content/carouselgallery`)(CarouselGallery);
    MapTo(`mi-aem-common-spa/components/content/linkbanner`)(LinkBanner);
    MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock);
    MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(CobrandCardHorizontalFlexible);
    MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(props => (
      <TabContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));
    MapTo(`mi-aem-legal-spa/components/content/contactusform`)(ContactUsForm);
    MapTo(`mi-aem-legal-spa/components/content/multilinks`)(LegalMultiLink);
    MapTo(`mi-aem-legal-spa/components/content/contenttabs`)(ContentTabs);
    MapTo(`mi-aem-legal-spa/components/content/legalconsents`)(LegalConsentValidator);
    MapTo(`mi-aem-legal-spa/components/content/legalmodal`)(ModalPageContent);
    MapTo(`mi-aem-legal-spa/components/content/membertier`)(props => (
      <LoyaltyTier {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-legal-spa/components/content/privacyrightswrapper`)(PrivacyRightsWrapper);
    MapTo(`mi-aem-legal-spa/components/content/cpraccpawrapper`)(PrivacyRightsWrapperV2);
    MapTo(`mi-aem-legal-spa/components/separator`)(LegalSeparator);
    MapTo('mi-aem-legal-spa/components/content/brgclaimform')(BrgClaimForm);
    MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(props => (
      <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered);
    MapTo(`mi-aem-common-spa/components/content/media`)(Media);
    MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
    MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);
    MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(Footer);

    MapTo(`mcom-book-spa/components/flyoutcontainer`)(
      props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'FlyoutDrawer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/accountcontainer`)(
      props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'accountcontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/signin`)(
      props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signin',
      }
    );
    MapTo(`mi-aem-account/components/content/signincontentblock`)(
      props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signincontentblock',
      }
    );
    MapTo(`mi-aem-account/components/content/accounttable`)(
      props => <AccountTableEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'AccountTable',
        isEmpty: false,
      }
    );
    const DataPageVariationConfig = {
      emptyLabel: 'Data Page',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
      const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
      const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
        />
      );
    }, DataPageVariationConfig);

    const existingMappings = Object.keys(AEM_REACT_MAPPING);

    // Validate allowedComponents before processing
    if (allowedComponents && Array.isArray(allowedComponents)) {
      let successCount = 0;
      let failureCount = 0;

      allowedComponents.forEach((mapping, index) => {
        try {
          // Validate mapping object structure
          if (!mapping || typeof mapping !== 'object') {
            throw new Error(`Invalid mapping object at index ${index}`);
          }

          if (!mapping.path || typeof mapping.path !== 'string') {
            throw new Error(`Invalid or missing path in mapping at index ${index}`);
          }

          const baseModelPath = '/jcr:content/root/responsivegrid/';
          const componentPath = mapping.path.split(baseModelPath)[1];

          if (!componentPath) {
            throw new Error(`Unable to extract component path from: ${mapping.path}`);
          }

          if (existingMappings.indexOf(componentPath) === -1) {
            MapTo(componentPath)(EditableHTLWrapper, {
              emptyLabel: mapping.title || 'Component',
              isEmpty: false,
            });
            successCount++;
          } else {
            if (process.env.NODE_ENV === 'development') {
              log('Mapping already exists, skipping:', componentPath);
            }
          }
        } catch (mappingError) {
          failureCount++;
          if (process.env.NODE_ENV === 'development') {
            logError(`Failed to map component at index ${index}:`, {
              error: mappingError.message,
              mapping: mapping,
              stack: mappingError.stack,
            });
          }
          // Continue processing remaining components
        }
      });

      if (process.env.NODE_ENV === 'development') {
        log(
          `Component mapping complete. Success: ${successCount}, Failed: ${failureCount}, Total: ${allowedComponents.length}`
        );
      }
    } else if (process.env.NODE_ENV === 'development') {
      log('No allowed components provided or invalid format');
    }
  } catch (err) {
    // Always log errors regardless of environment - use your server logger, not console
    logError('Critical error in defineComponentMapping:', {
      error: err.message,
      stack: err.stack,
    });
    // Re-throw so the caller (page bootstrap) can decide recovery strategy.
    // Silent failure here means EVERY AEM component renders as blank with zero observability.
    throw err;
  }
};
